//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  props: {
    image: {
      type: String,
      default: "/images/our-values-text-img.png",
    },
    header: {
      type: String,
      default: "no heading",
    },
    text: {
      type: String,
      default: "no text",
    },
  },
};
